import { render, staticRenderFns } from "./ChatComentarios.vue?vue&type=template&id=ac9443fe&scoped=true&"
import script from "./ChatComentarios.vue?vue&type=script&lang=js&"
export * from "./ChatComentarios.vue?vue&type=script&lang=js&"
import style0 from "./ChatComentarios.vue?vue&type=style&index=0&id=ac9443fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9443fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
})
